import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { getBrazilStatesGeo } from './services'
import type { TBrazilStatesGeoJSON } from './types'

export const useQueryBrazilStatesGeo = (
  options?: UseQueryOptions<TBrazilStatesGeoJSON, Error>
) => {
  const queryFunction = () => getBrazilStatesGeo()

  return useQuery<TBrazilStatesGeoJSON, Error>(
    useQueryBrazilStatesGeo.queryKey,
    queryFunction,
    options
  )
}

useQueryBrazilStatesGeo.queryKey = ['assets', 'brazil-states-geo']
